import { render, staticRenderFns } from "./BotonModuloActual2.vue?vue&type=template&id=01e55d7d"
import script from "./BotonModuloActual2.vue?vue&type=script&lang=js"
export * from "./BotonModuloActual2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports